import type { User } from 'src/types/user';

import { useAppSelector } from './store';

import type { SafeScarfState } from '@/types/safeScarf';

export const useUserData = (): User => useAppSelector(state => (state as { user: User }).user);
export const useSafeScarfData = (): SafeScarfState =>
  useAppSelector(state => state.safescarf as SafeScarfState);
